module.exports = __webpack_public_path__ + "img/logo.e30c25a3.png";